import { useState } from "react";

import { useEditStoreMutation } from "@modules/stores/services/mutations";
import { ActiveStoreSwitchProps } from "./types";

export function useActiveStoreSwitch({ id, value }: ActiveStoreSwitchProps) {
  const [isActive, setIsActive] = useState(value);

  const { mutateAsync, isPending } = useEditStoreMutation(id);

  const toggle = async () => {
    await mutateAsync({
      active: !isActive,
    });

    setIsActive((prev) => !prev);
  }

  return { isActive, isPending, toggle };
}
